/// <amd-module name="VSSUI/Components/InfoIcon/InfoIcon" />
import * as React from "react";
import { Callout } from "VSSUI/Callout";
import { css, KeyCode } from "VSSUI/Util";
import { IOrigin, Location } from "VSSUI/Utilities/Position";
import { getNativeProps, divProperties } from "OfficeFabric/Utilities";
import { IVssIconProps, VssIcon } from "VSSUI/VssIcon";

/** @deprecated */
export interface IInfoIconProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Positioning origin of the info icon against the callout (default horizontal.center, vertical.start) */
    iconOrigin?: IOrigin;
    /** Props for the icon */
    iconProps: IVssIconProps;
    /** Positioning origin of the callout against the info icon (default horizontal.center, vertical.end) */
    infoOrigin?: IOrigin;
    /** The text to display in the callout */
    infoText?: string;
    /** Optional render override for the callout */
    onRenderContent?: () => JSX.Element;
}
/** @deprecated */
export interface IInfoIconState {
    /** Is the callout open */
    calloutOpened: boolean;
}
/**
 * Icon which shows a callout with extra information when hovered
 */
/** @deprecated */
export class InfoIcon extends React.PureComponent<IInfoIconProps, IInfoIconState> {
    private _calloutTarget: React.RefObject<HTMLDivElement>;

    constructor(props: IInfoIconProps) {
        super(props);
        this._calloutTarget = React.createRef();
        this.state = {
            calloutOpened: false
        };
    }

    public render(): JSX.Element {
        const {
            iconOrigin = { horizontal: Location.center, vertical: Location.start },
            iconProps,
            infoOrigin = { horizontal: Location.center, vertical: Location.end },
            infoText
        } = this.props;

        const { calloutOpened } = this.state;

        return (
            <div
                aria-label={infoText}
                {...getNativeProps(this.props, divProperties)}
                ref={this._calloutTarget}
                onBlur={this._onDismiss}
                onClick={this._onClick}
                onKeyDown={this._onKeyDown}
                role="button"
                tabIndex={0}
            >
                <VssIcon {...iconProps} className={css(iconProps.className, "vss-info-icon")} />
                {calloutOpened && (
                    <Callout
                        anchorElement={this._calloutTarget.current!}
                        anchorOrigin={iconOrigin}
                        calloutOrigin={infoOrigin}
                        contentClassName="vss-info-callout"
                        contentShadow={true}
                        onDismiss={this._onDismiss}
                    >
                        {this._renderCalloutContent()}
                    </Callout>
                )}
            </div>
        );
    }
    private _renderCalloutContent(): JSX.Element {
        const { infoText, onRenderContent } = this.props;
        if (onRenderContent) {
            return onRenderContent();
        } else {
            return <div className="vss-info-text-container">{infoText}</div>;
        }
    }

    private _onClick = (): void => {
        this.setState({ calloutOpened: true });
    };

    private _onKeyDown = (event: React.KeyboardEvent<HTMLElement>): void => {
        if (event.keyCode === KeyCode.enter || event.keyCode === KeyCode.space) {
            this.setState({ calloutOpened: true });
        }
    };

    private _onDismiss = (): void => {
        this.setState({ calloutOpened: false });
    };
}
